// extracted by mini-css-extract-plugin
export default {"gridRow":"GridBody_gridRow__njVbZ","gridTick":"GridBody_gridTick__bzcfp"};